import { useEffect, useState } from 'react';
import type { SettingsState } from '../types';

const STORAGE_KEY = 'crossword.settings';
const COOKIE_KEY = 'crossword_settings';

const DEFAULT_SETTINGS: SettingsState = {
  playerName: 'Player',
  theme: 'light',
  mode: 'competitive',
  playType: 'free-for-all',
  answerCheckMode: 'easy',
  turnLimit: 120,
};

function readSettings(): SettingsState {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  const cookieRaw = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${COOKIE_KEY}=`))
    ?.slice(COOKIE_KEY.length + 1);
  if (!raw && !cookieRaw) return DEFAULT_SETTINGS;
  try {
    return {
      ...DEFAULT_SETTINGS,
      ...JSON.parse(raw ?? decodeURIComponent(cookieRaw ?? '{}')),
    } as SettingsState;
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function useSettings() {
  const [settings, setSettings] = useState<SettingsState>(() => readSettings());

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(JSON.stringify(settings))}; Max-Age=604800; SameSite=Strict; Path=/`;
    document.documentElement.dataset.theme = settings.theme;
  }, [settings]);

  return { settings, setSettings };
}
